export const getPaginationArgs = (
  pageSize: number,
  currentPage = 1,
): { skip: number; take: number } => {
  return {
    skip: pageSize * (currentPage - 1),
    take: pageSize,
  };
};
